import { render } from "./AppFooter.vue?vue&type=template&id=73c150cd"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mirox/Desktop/coreui-free-vue-admin-template-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__